import { createContext, useContext } from 'react'
import { useIsMiniOnLeftSide } from '../../atoms'

/**
 * Overrides which edge a Mini subtree is anchored to. The notched layout renders two
 * halves that grow away from the notch, so each half declares its own anchoring rather
 * than following the persisted left/right side.
 */
const MiniAnchorContext = createContext<boolean | null>(null)

export const MiniAnchorProvider = MiniAnchorContext.Provider

export function useIsMiniAnchoredLeft(): boolean {
  const override = useContext(MiniAnchorContext)
  const isOnLeftSide = useIsMiniOnLeftSide()
  return override ?? isOnLeftSide
}
